import React from "react";
import PropTypes from "prop-types";
import { TimelineLite } from "gsap";
import globals from "../globals";
import PlainText from "../modules/PlainText";

const ExpandableList = (props) => {

    const items = [];
    const rects = [];
    const circles = [];

    const handleClick = (key) => {
        let item = items[key];
        let rect = rects[key];
        let circle = circles[key];

        if (items[key].classList.contains('closed')) {
            animateOpen(item, rect, circle);
        } else {
            animateClosed(item, rect, circle);
        }
    };

    const animateOpen = (item, rect, circle) => {
        item.classList.remove('closed');
        item.classList.add('open');

        let tl = new TimelineLite(),
            title = item.querySelector('.title'),
            content = item.querySelector('.content');

        tl.set(content, {display: 'block', height: 'auto', paddingTop: '20px', paddingBottom: '20px'});
        tl.set(title, {paddingBottom: 0});
        tl.from(content, 0.25, {height: 0});
        tl.to(content, 0.2, {opacity: 1}, 0);
        tl.to(rect, 0.2, {rotation: 90, transformOrigin: '50% 50%'}, 0);
        tl.to(circle, 0.2, {opacity: 0.45}, 0);
    };

    const animateClosed = (item, rect, circle) => {
        item.classList.remove('open');
        item.classList.add('closed');

        let tl = new TimelineLite(),
            title = item.querySelector('.title'),
            content = item.querySelector('.content');

        tl.to(content,0.25, {height: 0, paddingTop: 0, paddingBottom: 0});
        tl.to(title, 0.25, {paddingBottom: '20px'}, 0);
        tl.set(content, {display: 'none', height: 'auto'});
        tl.to(rect, 0.2, {rotation: 0, transformOrigin: '50% 50%'}, 0);
        tl.to(circle, 0.2, {opacity: 0.45}, 0);
    };

    return (
        <div className="expandable-list">
            {props.data.map((item, key) => {
                return (
                    <div key={key} className="item closed" ref={el => items[key] = el}>
                        <div className={`title ${props.hasBoldTitles ? 'bold' : ''}`} onClick={() => handleClick(key)} dangerouslySetInnerHTML={{__html: globals.noWidows(item[0])}} />
                        <div className="content font-small-mb">
                            <PlainText data={item} excludeTitle={true} />
                        </div>
                        <svg width="30px" height="30px" viewBox="0 0 30 30" className="icon" onClick={() => handleClick(key)}>
                            <circle ref={el => circles[key] = el} fill="#63D481" opacity="0.45" cx="15" cy="15" r="15" />
                            <rect ref={el => rects[key] = el} fill="#004346" x="13" y="7" width="4" height="16" />
                            <rect fill="#004346" transform="translate(15.000000, 15.000000) rotate(-90.000000) translate(-15.000000, -15.000000) " x="13" y="7" width="4" height="16" />
                        </svg>
                    </div>
                );
            })}
        </div>
    );

};

ExpandableList.propTypes = {
    data: PropTypes.array.isRequired,
    hasBoldTitles: PropTypes.bool
};

export default ExpandableList;


// WEBPACK FOOTER //
// ./resources/assets/js/components/ExpandableList.js